
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"131","height":"131"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M65.709.505C29.889.505.852 29.543.852 65.362c0 35.82 29.037 64.858 64.857 64.858s64.857-29.038 64.857-64.858c0-35.819-29.037-64.857-64.857-64.857zm0 118.905c-29.802 0-54.048-24.245-54.048-54.048 0-29.802 24.246-54.047 54.048-54.047 29.802 0 54.048 24.245 54.048 54.047 0 29.803-24.246 54.048-54.048 54.048zm0-91.881c-4.756 0-8.107 4.001-8.107 8.108s3.351 8.107 8.107 8.107c4.754 0 8.107-3.677 8.107-8.107 0-4.432-3.353-8.108-8.107-8.108zm-5.405 75.667h10.81V54.553h-10.81v48.643z"}})])
          )
        }
      }
    